import React from "react";
import PropTypes from "prop-types";
import { Link, graphql } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import Seo from "../components/Seo";

import Layout from "../components/Layout";
import Content, { HTMLContent } from "../components/Content";

import FullWidthImage from "../components/FullWidthImage";
import DisplayContentHeader from "../components/DisplayContentHeader";
import PreviewCompatibleImage from "../components/PreviewCompatibleImage";
import StoreBrandList from "../components/StoreBrandList";
// eslint-disable-next-line
export const BrandsPageTemplate = ({
  title,
  subtitle,
  image,
  meta,
  body,
  helmet,
  brand,
}) => {
  const PageContent = HTMLContent || Content;
  const heroImage = getImage(image) || image;
  let linkedImage;
  if (brand && brand.url && brand.url.indexOf("http") === -1) {
    // local link
    linkedImage = (
      <>
        <Link to="/store/">
          {" "}
          <PreviewCompatibleImage
            imageInfo={{
              image: brand.image,
              alt: title,
              className: "brand-image mt-4",
            }}
          />
        </Link>
      </>
    );
  } else {
    linkedImage = (
      <>
        <a href={brand.url}>
          {" "}
          <PreviewCompatibleImage
            imageInfo={{
              image: brand.image,
              alt: title,
              className: "brand-image mt-4",
            }}
          />
        </a>
      </>
    );
  }

  const showTitle = meta.showTitle;

  return (
    <div>
      {helmet || null}

      {showTitle ? (
        <FullWidthImage
          img={heroImage}
          title={title}
          subheading={subtitle}
          imgPosition="center"
        />
      ) : (
        <FullWidthImage img={heroImage} imgPosition="center" />
      )}

      <section className="section section--gradient">
        <div className="container">
          <div className="content">
            <div className="content">
              <div className="brand-image">{linkedImage}</div>
              <DisplayContentHeader
                title={title}
                parent={meta.parent}
                parentSlug={meta.parentSlug}
                grandparent={meta.grandparent}
                grandparentSlug={meta.grandparentSlug}
              />
            </div>

            <PageContent
              className="content content___brand-page"
              content={body}
            />
            <StoreBrandList brand={title} />
            <br clear="right" />
          </div>
        </div>
      </section>
    </div>
  );
};

BrandsPageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  meta: PropTypes.shape({
    showTitle: PropTypes.bool,
    parent: PropTypes.string,
    parentSlug: PropTypes.string,
    grandparent: PropTypes.string,
    grandparentSlug: PropTypes.string,
  }),
  body: PropTypes.string,
  helmet: PropTypes.object,
  brand: PropTypes.object,
};

const BrandsPage = ({ data }) => {
  const { markdownRemark: post } = data;

  let imageSrc =
    post.frontmatter.image.childImageSharp.gatsbyImageData.images.fallback.src;

  return (
    <Layout>
      <BrandsPageTemplate
        title={post.frontmatter.title}
        subtitle={post.frontmatter.subtitle}
        image={post.frontmatter.image}
        meta={post.frontmatter.meta}
        body={post.html}
        helmet={
          <Seo
            title={post.frontmatter.title}
            summary={post.frontmatter.summary}
            image={imageSrc}
            article={false}
          />
        }
        brand={post.frontmatter.brand}
      />
    </Layout>
  );
};

BrandsPage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default BrandsPage;

export const brandsPageQuery = graphql`
  query BrandsPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      fields {
        slug
      }
      frontmatter {
        title
        subtitle
        image {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              layout: FULL_WIDTH
              placeholder: BLURRED
            )
          }
        }
        brand {
          url
          image {
            childImageSharp {
              gatsbyImageData(
                quality: 100
                layout: FULL_WIDTH
                placeholder: BLURRED
              )
            }
          }
        }
        meta {
          showTitle
          parent
          parentSlug
          grandparent
          grandparentSlug
        }
        summary
      }
    }
  }
`;
